import { createAction } from '@ngrx/store';
import { mpFlightTransactionFeatureKey } from './mp-flight-transaction-service.state';
import { CertificateTransactionInfoResponse } from '../../../dtos/response/certificate-transaction-info-response/certificate-transaction-info-response';

export const initializeMPFlightTransactionServiceState = createAction(`[${mpFlightTransactionFeatureKey}] Initialize`);

export const getCertificateTransactionInfo = createAction(
  `[${mpFlightTransactionFeatureKey}] Get certificate transaction info`,
  (certificateNumbers: string[]) => ({
    certificateNumbers,
  })
);

export const getCertificateTransactionInfoSuccess = createAction(
  `[${mpFlightTransactionFeatureKey}] Get certificate transaction info success`,
  (response: CertificateTransactionInfoResponse) => ({
    response,
  })
);

export const getCertificateTransactionInfoFailure = createAction(
  `[${mpFlightTransactionFeatureKey}] Get certificate transaction info failure`,
  (response: CertificateTransactionInfoResponse) => ({
    response,
  })
);
